/**
 * Filter function used to filter out types in Comms management page.
 */
(function() {
    'use strict';

    angular.module('app').filter('communicationTypeFilter', function() {

        return function(input, communicationTypes) {
            if (!communicationTypes || communicationTypes.length === 0) return input;
            var out = [];
            angular.forEach(input, function (item) {
                angular.forEach(communicationTypes, function (communicationType) {
                    if(item.typeKey){
                        if (item.typeKey === communicationType.type) {
                            out.push(item);
                        }
                    }
                });
            });
            return out;
        }
    });

}());